<template>
  <div class="popup-cart-mask" @click.self="$emit('close')">
    <div class="popup-cart">

      <!-- HEADER -->
      <div class="cart-header">
        <span>🛒 Giỏ hàng</span>
        <button style="background: none;
    border: none;" @click="$emit('close')">✕</button>
      </div>

      <!-- MOBILE TABS -->
      <div class="cart-tabs">
        <div class="tab" :class="{ active: activeTab === 'rent' }" @click="activeTab = 'rent'">
          📦 Thuê
        </div>
        <div class="tab" :class="{ active: activeTab === 'buy' }" @click="activeTab = 'buy'">
          🛒 Mua
        </div>
      </div>

      <!-- BODY -->
      <div class="cart-body">

        <!-- 📦 THUÊ -->
        <div class="cart-col rent" :class="{ show: activeTab === 'rent' }">
          <div class="col-title">
            📦 Thuê
          </div>

          <!-- LIST SCROLL -->
          <div class="cart-list">
            <div v-if="!rentItems.length" class="empty">
              Không có sản phẩm thuê
            </div>

            <div v-for="(item, i) in rentItems" :key="'r' + i" class="cart-item">
              <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id='+item.image" />
              <div class="info">
                <div class="name">{{ item.name }}</div>
                <div class="meta">
                  SL: {{ item.quantity }} •
                  <strong style="color: red; font-size: 13px;">{{ formatPrice(item.total) }}₫</strong>
                </div>
              </div>
<span class="remove" @click="$emit('remove', { item, type: 'rent' })">✕</span>            </div>
          </div>

          <!-- BUTTON STICKY -->
          <button v-if="rentItems.length" class="btn rent sticky-btn" @click="openCheckout('rent')">
            📦 THUÊ {{ formatPrice(rentTotal) }}₫
          </button>
        </div>

        <!-- 🛒 MUA -->
        <div class="cart-col buy" :class="{ show: activeTab === 'buy' }">
          <div class="col-title">
            🛒 Mua
          </div>

          <!-- LIST SCROLL -->
          <div class="cart-list">
            <div v-if="!buyItems.length" class="empty">
              Không có sản phẩm mua
            </div>

            <div v-for="(item, i) in buyItems" :key="'b' + i" class="cart-item">
              <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id='+item.image" />
              <div class="info">
                <div class="name">{{ item.name }}</div>
                <div class="meta">
                  SL: {{ item.quantity }} •
                  <b>{{ formatPrice(item.total) }}₫</b>
                </div>
              </div>
<span class="remove" @click="$emit('remove', { item, type: 'buy' })">✕</span>            </div>
          </div>

          <!-- BUTTON STICKY -->
          <button v-if="buyItems.length" class="btn buy sticky-btn" @click="openCheckout('buy')">
            🛒 ĐẶT HÀNG {{ formatPrice(buyTotal) }}₫
          </button>
        </div>

      </div>
    </div>
  </div>
  <div v-if="showCheckout" class="popup-cart-mask">
    <div class="popup-cart small">
      <div class="cart-header">
        <span>
          {{ orderType === 'rent' ? '📦 Đơn thuê' : '🛒 Đơn mua' }}
        </span>
        <button style="background: none; border: none;" @click="showCheckout = false">✕</button>
      </div>

      <div class="checkout-body">
        <input v-model="customer.name" placeholder="Họ tên *" />
        <input v-model="customer.phone" placeholder="SĐT *" />
        <input v-model="customer.email" placeholder="Email" />
        <textarea v-model="customer.address" placeholder="Địa chỉ *"></textarea>
        <div v-if="orderType === 'rent'" class="agree-box">
          <div class="deposit-box">
            <ul>
              <li>💰 Cọc thuê = <b>1 tháng tiền thuê</b></li>
              <li>⛔ Không cho thuê lại, gia hạn/trả báo trước <b>1 tháng</b></li>
              <li>🔧 Hư hỏng, mất mát bồi thường theo giá thị trường</li>
              <li>📅 Sau 12 tháng được thuê tiếp hoặc mua theo giá trị còn lại</li>
              <li>💳 <b>Bắt buộc tải và đăng ký <a href="https://vimass.vn" target="_blank" rel="noopener">
                    Ví Vimass
                  </a> </b> để cọc & hoàn cọc</li>
            </ul>
          </div>
          <label class="agree-item mt-3 d-flex">
            <input type="checkbox" v-model="agreePolicy" />
            <span>
              Tôi đồng ý với điều khoản thuê

            </span>
          </label>
        </div>

      </div>

      <div class="col-footer">
        <button class="btn" :class="orderType" @click="submitOrder" :disabled="orderType === 'rent' && !agreePolicy">
          <template v-if="orderType === 'rent'">
            📦 Thuê ngay – {{ formatPrice(rentTotal) }}₫
          </template>
          <template v-else>
            🛒 Đặt hàng – {{ formatPrice(buyTotal) }}₫
          </template>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      activeTab: 'rent',

      showCheckout: false,
      agreePolicy: false,
      orderType: null, // 'rent' | 'buy'
      customer: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      vimassChecked: false,
      vimassExists: false,
      checkingVimass: false
    }
  },

  computed: {
    rentItems() {
      return this.items.filter(i => i.type === 'rent')
    },
    buyItems() {
      return this.items.filter(i => i.type === 'buy')
    },
    rentTotal() {
      return this.rentItems.reduce((s, i) => s + Number(i.total || 0), 0)
    },
    buyTotal() {
      return this.buyItems.reduce((s, i) => s + Number(i.total || 0), 0)
    }
  },

  methods: {
    formatPrice(v) {
      return Number(v || 0).toLocaleString('vi-VN')
    },
    openCheckout(type) {
      this.orderType = type
      this.showCheckout = true
    },
    submitOrder() {
      if (!this.customer.name || !this.customer.phone || !this.customer.address) {
        alert('Vui lòng nhập đầy đủ thông tin')
        return
      }

      if (this.orderType === 'rent' && !this.agreePolicy) {
        alert('Vui lòng đồng ý điều khoản thuê')
        return
      }
      alert('🚧 Chức năng đang phát triển, vui lòng quay lại sau!')

      // const list = this.orderType === 'rent' ? this.rentItems : this.buyItems
      // const total = this.orderType === 'rent' ? this.rentTotal : this.buyTotal
      // const title = this.orderType === 'rent' ? '📦 ĐƠN THUÊ' : '🛒 ĐƠN MUA'

      // let msg = `${title}\n`
      // msg += `👤 ${this.customer.name}\n`
      // msg += `📞 ${this.customer.phone}\n`
      // msg += `📍 ${this.customer.address}\n\n`

      // list.forEach((i, idx) => {
      //   msg += `${idx + 1}. ${i.name} x${i.quantity}\n`
      // })

      // msg += `\n💰 Tổng tiền: ${this.formatPrice(total)}₫`

      // window.open(
      //   `https://zalo.me/0979951954?text=${encodeURIComponent(msg)}`,
      //   '_blank'
      // )
    }


  }
}
</script>

<style scoped>
/* ===== BASE ===== */
.popup-cart-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-cart {
  width: 900px;
  max-width: 95%;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cart-header {
  display: flex;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  font-weight: 700;
}

.cart-tabs {
  display: none;
}

.cart-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px;
}

.cart-col {
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
}

.col-title {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  margin-bottom: 10px;
}

.col-total.rent {
  color: #ee4d2d
}

.col-total.buy {
  color: #1976d2
}

/* LIST */
.cart-list {
  flex: 1;
}

.cart-item {
  display: flex;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.cart-item img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.info {
  flex: 1
}

.name {
  font-weight: 600;
  font-size: 14px;
}

.meta {
  font-size: 13px;
  color: #666;
}

.remove {
  cursor: pointer;
  color: #999;
}

/* BUTTON */
.btn {
  margin-top: 10px;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  border: none;
  color: #fff;
}

.btn.rent {
  background: linear-gradient(135deg, #ff7043, #d84315);
}

.btn.buy {
  background: linear-gradient(135deg, #1976d2, #0d47a1);
}

.empty {
  color: #999;
  text-align: center;
  padding: 20px;
}

/* ===== MOBILE MODE ===== */
@media (max-width: 768px) {
  .popup-cart {
    width: 100%;
    height: 100dvh;
    border-radius: 0;
  }

  .cart-tabs {
    display: flex;
    border-bottom: 1px solid #eee;
  }

  .cart-tabs .tab {
    flex: 1;
    text-align: center;
    padding: 12px;
    font-weight: 700;
    cursor: pointer;
    color: #777;
  }

  .cart-tabs .tab span {
    display: block;
    font-size: 13px;
  }

  .cart-tabs .tab.active {
    color: #000;
    border-bottom: 3px solid #1976d2;
  }

  .cart-body {
    grid-template-columns: 1fr;
    padding: 10px;
    height: calc(100vh - 110px);
  }

  .cart-col {
    display: none;
    height: 100%;
  }

  .cart-col.show {
    display: flex;
  }

  .cart-list {
    overflow-y: auto;
    padding-bottom: 90px;
  }

  .sticky-btn {
    position: sticky;
    bottom: 0;
    z-index: 10;
  }
}

/* ===== MODAL ĐẶT HÀNG ===== */

.checkout-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* INPUT */
.checkout-body input,
.checkout-body textarea {
  width: 100%;
  padding: 14px 14px;
  border-radius: 12px;
  border: 1px solid #ddd;
  font-size: 15px;
  outline: none;
  transition: .2s;
}

.checkout-body input:focus,
.checkout-body textarea:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, .1);
}

.checkout-body textarea {
  min-height: 90px;
  resize: none;
}

/* LƯU Ý THUÊ */
.deposit-box {
  background: linear-gradient(135deg, #fff3e0, #ffe0b2);
  border-left: 4px solid #ff9800;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  color: #5d4037;
}

/* FOOTER BUTTON */
.col-footer {
  padding: 16px;
  border-top: 1px solid #eee;
  margin-top: auto;
}

.col-footer .btn {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  border-radius: 14px;
  font-weight: 700;
}

/* HEADER FIX */
.popup-cart.small {
  /* max-width: 420px; */
  height: auto;
}

/* MOBILE TỐI ƯU */
@media (max-width: 480px) {
  .popup-cart.small {
    width: 92%;
  }

  .checkout-body {
    padding: 14px;
  }

  .col-footer {
    padding: 14px;
  }
}

/* ===== AGREE BOX ===== */
.agree-box {
  background: #f9fafb;
  border-radius: 14px;
  padding: 12px;
  margin-top: 10px;
  font-size: 14px;
}

.agree-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-weight: 600;
}

.agree-item input {
  width: 18px;
  height: 18px;
  margin-top: 3px;
}

.agree-item a {
  color: #1976d2;
  text-decoration: underline;
}

/* POLICY TEXT */
.policy-text {
  margin-top: 8px;
  font-size: 13px;
  color: #555;
}

.policy-text ul {
  padding-left: 18px;
  margin: 0;
}

.policy-text li {
  margin-bottom: 4px;
}

/* MOBILE FIX */
@media (max-width: 480px) {
  .popup-cart.small {
    width: 94%;
    max-height: 92vh;
  }

  .checkout-body {
    padding: 14px;
    overflow-y: auto;
  }

  .agree-box {
    font-size: 13px;
  }
}
</style>